import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames";
import { isMobile } from "react-device-detect";

import PreloadIcon from "./PreloadIcon";
import { _sharedActionsSystem } from "../../store/system/actions";
import {
  DATA_ACQUISITION_STATUS,
  LOADING_TYPES,
  minLoadingTimeInMilliseconds,
  minLoadingTimeInMillisecondsDefault,
} from "./Loader.constants";
import { selectorSetting } from "../../store/settings/selectors";
import { SETTING } from "../../utils/settings/constants";

import styles from "./Loader.module.scss";

const Loader = ({ align, className, sizeSmall, size, type, isPositionAbsolute }) => {
  const dispatch = useDispatch();
  const textMode = useSelector(selectorSetting(SETTING.textMode.id));

  useEffect(() => {
    const startTime = Date.now();
    return () => {
      // Darryl and some users face the problem, "Poor connection" screen is shown,
      // after previously leaved tab is opened.
      // So no need to show popup if tab is not visible.
      if (document.visibilityState === "visible") {
        const delta = Date.now() - startTime;
        const minTime = type
          ? minLoadingTimeInMilliseconds[type]
          : minLoadingTimeInMillisecondsDefault;
        if (minTime && !textMode) {
          if (delta > minTime) {
            dispatch(_sharedActionsSystem.updateDataAcquisitionStatus(DATA_ACQUISITION_STATUS.LOW));
          }
        }
      }
    };
  }, [type]);

  let sizeFinal;

  if (size !== undefined) {
    sizeFinal = size;
  } else if (sizeSmall) {
    sizeFinal = 50;
  } else {
    if (isMobile) {
      sizeFinal = 63;
    } else {
      sizeFinal = 100;
    }
  }

  return (
    <div
      className={classNames(styles["loader-wrap"], className, styles[align], {
        [styles["position-absolute"]]: isPositionAbsolute,
      })}>
      <PreloadIcon size={sizeFinal} />
    </div>
  );
};

Loader.types = LOADING_TYPES;

Loader.propTypes = {
  type: PropTypes.string,
  sizeSmall: PropTypes.bool,
  size: PropTypes.number,
  isPositionAbsolute: PropTypes.bool,
  align: PropTypes.oneOf(["flex-center", "hor-center"]),
  className: PropTypes.string,
};

export default Loader;
